(function () {
  'use strict';

  let _WINDOW = {};
  let _DOCUMENT = {};
  try {
    if (typeof window !== 'undefined') _WINDOW = window;
    if (typeof document !== 'undefined') _DOCUMENT = document;
  } catch (e) {}
  const {
    userAgent = ''
  } = _WINDOW.navigator || {};
  const WINDOW = _WINDOW;
  const DOCUMENT = _DOCUMENT;
  const IS_BROWSER = !!WINDOW.document;
  const IS_DOM = !!DOCUMENT.documentElement && !!DOCUMENT.head && typeof DOCUMENT.addEventListener === 'function' && typeof DOCUMENT.createElement === 'function';
  const IS_IE = ~userAgent.indexOf('MSIE') || ~userAgent.indexOf('Trident/');

  function _defineProperty(e, r, t) {
    return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
      value: t,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[r] = t, e;
  }
  function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var o = Object.getOwnPropertySymbols(e);
      r && (o = o.filter(function (r) {
        return Object.getOwnPropertyDescriptor(e, r).enumerable;
      })), t.push.apply(t, o);
    }
    return t;
  }
  function _objectSpread2(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = null != arguments[r] ? arguments[r] : {};
      r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
        _defineProperty(e, r, t[r]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
        Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
      });
    }
    return e;
  }
  function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
      var i = e.call(t, r || "default");
      if ("object" != typeof i) return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
  }
  function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
  }

  var S = {
      classic: {
        fa: "solid",
        fas: "solid",
        "fa-solid": "solid",
        far: "regular",
        "fa-regular": "regular",
        fal: "light",
        "fa-light": "light",
        fat: "thin",
        "fa-thin": "thin",
        fab: "brands",
        "fa-brands": "brands"
      },
      duotone: {
        fa: "solid",
        fad: "solid",
        "fa-solid": "solid",
        "fa-duotone": "solid",
        fadr: "regular",
        "fa-regular": "regular",
        fadl: "light",
        "fa-light": "light",
        fadt: "thin",
        "fa-thin": "thin"
      },
      sharp: {
        fa: "solid",
        fass: "solid",
        "fa-solid": "solid",
        fasr: "regular",
        "fa-regular": "regular",
        fasl: "light",
        "fa-light": "light",
        fast: "thin",
        "fa-thin": "thin"
      },
      "sharp-duotone": {
        fa: "solid",
        fasds: "solid",
        "fa-solid": "solid",
        fasdr: "regular",
        "fa-regular": "regular",
        fasdl: "light",
        "fa-light": "light",
        fasdt: "thin",
        "fa-thin": "thin"
      }
    };
  var s = "classic";
  var G = {
      classic: {
        900: "fas",
        400: "far",
        normal: "far",
        300: "fal",
        100: "fat"
      },
      duotone: {
        900: "fad",
        400: "fadr",
        300: "fadl",
        100: "fadt"
      },
      sharp: {
        900: "fass",
        400: "fasr",
        300: "fasl",
        100: "fast"
      },
      "sharp-duotone": {
        900: "fasds",
        400: "fasdr",
        300: "fasdl",
        100: "fasdt"
      }
    };
  var xt = {
      classic: {
        solid: "fas",
        regular: "far",
        light: "fal",
        thin: "fat",
        brands: "fab"
      },
      duotone: {
        solid: "fad",
        regular: "fadr",
        light: "fadl",
        thin: "fadt"
      },
      sharp: {
        solid: "fass",
        regular: "fasr",
        light: "fasl",
        thin: "fast"
      },
      "sharp-duotone": {
        solid: "fasds",
        regular: "fasdr",
        light: "fasdl",
        thin: "fasdt"
      }
    };
  var St = {
      kit: {
        fak: "kit",
        "fa-kit": "kit"
      },
      "kit-duotone": {
        fakd: "kit-duotone",
        "fa-kit-duotone": "kit-duotone"
      }
    };
  var Ct = {
    kit: {
      "fa-kit": "fak"
    },
    "kit-duotone": {
      "fa-kit-duotone": "fakd"
    }
  };
  var Wt = {
      kit: {
        fak: "fa-kit"
      },
      "kit-duotone": {
        fakd: "fa-kit-duotone"
      }
    };
  var Et = {
      kit: {
        kit: "fak"
      },
      "kit-duotone": {
        "kit-duotone": "fakd"
      }
    };

  var ua = {
      classic: {
        "fa-brands": "fab",
        "fa-duotone": "fad",
        "fa-light": "fal",
        "fa-regular": "far",
        "fa-solid": "fas",
        "fa-thin": "fat"
      },
      duotone: {
        "fa-regular": "fadr",
        "fa-light": "fadl",
        "fa-thin": "fadt"
      },
      sharp: {
        "fa-solid": "fass",
        "fa-regular": "fasr",
        "fa-light": "fasl",
        "fa-thin": "fast"
      },
      "sharp-duotone": {
        "fa-solid": "fasds",
        "fa-regular": "fasdr",
        "fa-light": "fasdl",
        "fa-thin": "fasdt"
      }
    },
    ga = {
      classic: {
        fab: "fa-brands",
        fad: "fa-duotone",
        fal: "fa-light",
        far: "fa-regular",
        fas: "fa-solid",
        fat: "fa-thin"
      },
      duotone: {
        fadr: "fa-regular",
        fadl: "fa-light",
        fadt: "fa-thin"
      },
      sharp: {
        fass: "fa-solid",
        fasr: "fa-regular",
        fasl: "fa-light",
        fast: "fa-thin"
      },
      "sharp-duotone": {
        fasds: "fa-solid",
        fasdr: "fa-regular",
        fasdl: "fa-light",
        fasdt: "fa-thin"
      }
    };

  const NAMESPACE_IDENTIFIER = '___FONT_AWESOME___';
  const PRODUCTION = (() => {
    try {
      return "production" === 'production';
    } catch (e$$1) {
      return false;
    }
  })();
  function familyProxy(obj) {
    // Defaults to the classic family if family is not available
    return new Proxy(obj, {
      get(target, prop) {
        return prop in target ? target[prop] : target[s];
      }
    });
  }
  const _PREFIX_TO_STYLE = _objectSpread2({}, S);

  // We changed FACSSClassesToStyleId in the icons repo to be canonical and as such, "classic" family does not have any
  // duotone styles.  But we do still need duotone in _PREFIX_TO_STYLE below, so we are manually adding
  // {'fa-duotone': 'duotone'}
  _PREFIX_TO_STYLE[s] = _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, {
    'fa-duotone': 'duotone'
  }), S[s]), St['kit']), St['kit-duotone']);
  const PREFIX_TO_STYLE = familyProxy(_PREFIX_TO_STYLE);
  const _STYLE_TO_PREFIX = _objectSpread2({}, xt);

  // We changed FAStyleIdToShortPrefixId in the icons repo to be canonical and as such, "classic" family does not have any
  // duotone styles.  But we do still need duotone in _STYLE_TO_PREFIX below, so we are manually adding {duotone: 'fad'}
  _STYLE_TO_PREFIX[s] = _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, {
    duotone: 'fad'
  }), _STYLE_TO_PREFIX[s]), Et['kit']), Et['kit-duotone']);
  const STYLE_TO_PREFIX = familyProxy(_STYLE_TO_PREFIX);
  const _PREFIX_TO_LONG_STYLE = _objectSpread2({}, ga);
  _PREFIX_TO_LONG_STYLE[s] = _objectSpread2(_objectSpread2({}, _PREFIX_TO_LONG_STYLE[s]), Wt['kit']);
  const PREFIX_TO_LONG_STYLE = familyProxy(_PREFIX_TO_LONG_STYLE);
  const _LONG_STYLE_TO_PREFIX = _objectSpread2({}, ua);
  _LONG_STYLE_TO_PREFIX[s] = _objectSpread2(_objectSpread2({}, _LONG_STYLE_TO_PREFIX[s]), Ct['kit']);
  const LONG_STYLE_TO_PREFIX = familyProxy(_LONG_STYLE_TO_PREFIX);
  const _FONT_WEIGHT_TO_PREFIX = _objectSpread2({}, G);
  const FONT_WEIGHT_TO_PREFIX = familyProxy(_FONT_WEIGHT_TO_PREFIX);

  function bunker(fn) {
    try {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      fn(...args);
    } catch (e) {
      if (!PRODUCTION) {
        throw e;
      }
    }
  }

  const w = WINDOW || {};
  if (!w[NAMESPACE_IDENTIFIER]) w[NAMESPACE_IDENTIFIER] = {};
  if (!w[NAMESPACE_IDENTIFIER].styles) w[NAMESPACE_IDENTIFIER].styles = {};
  if (!w[NAMESPACE_IDENTIFIER].hooks) w[NAMESPACE_IDENTIFIER].hooks = {};
  if (!w[NAMESPACE_IDENTIFIER].shims) w[NAMESPACE_IDENTIFIER].shims = [];
  var namespace = w[NAMESPACE_IDENTIFIER];

  function normalizeIcons(icons) {
    return Object.keys(icons).reduce((acc, iconName) => {
      const icon = icons[iconName];
      const expanded = !!icon.icon;
      if (expanded) {
        acc[icon.iconName] = icon.icon;
      } else {
        acc[iconName] = icon;
      }
      return acc;
    }, {});
  }
  function defineIcons(prefix, icons) {
    let params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    const {
      skipHooks = false
    } = params;
    const normalized = normalizeIcons(icons);
    if (typeof namespace.hooks.addPack === 'function' && !skipHooks) {
      namespace.hooks.addPack(prefix, normalizeIcons(icons));
    } else {
      namespace.styles[prefix] = _objectSpread2(_objectSpread2({}, namespace.styles[prefix] || {}), normalized);
    }

    /**
     * Font Awesome 4 used the prefix of `fa` for all icons. With the introduction
     * of new styles we needed to differentiate between them. Prefix `fa` is now an alias
     * for `fas` so we'll ease the upgrade process for our users by automatically defining
     * this as well.
     */
    if (prefix === 'fas') {
      defineIcons('fa', icons);
    }
  }

  var icons = {
    
    "angle-down": [448,512,["8964"],"f107","M224 397.3l22.6-22.6 160-160L429.3 192 384 146.7l-22.6 22.6L224 306.7 86.6 169.4 64 146.7 18.7 192l22.6 22.6 160 160L224 397.3z"],
    "angle-left": [320,512,["8249"],"f104","M18.7 256l22.6 22.6 160 160L224 461.3 269.3 416l-22.6-22.6L109.3 256 246.6 118.6 269.3 96 224 50.7 201.4 73.4l-160 160L18.7 256z"],
    "angle-right": [320,512,["8250"],"f105","M301.3 256l-22.6 22.6-160 160L96 461.3 50.7 416l22.6-22.6L210.7 256 73.4 118.6 50.7 96 96 50.7l22.6 22.6 160 160L301.3 256z"],
    "angle-up": [448,512,["8963"],"f106","M224 114.7l22.6 22.6 160 160L429.3 320 384 365.3l-22.6-22.6L224 205.3 86.6 342.6 64 365.3 18.7 320l22.6-22.6 160-160L224 114.7z"],
    "arrow-down": [384,512,["8595"],"f063","M214.6 454.6L192 477.3l-22.6-22.6-144-144L2.7 288 48 242.8l22.6 22.6L160 354.8 160 64l0-32 64 0 0 32 0 290.7 89.4-89.4L336 242.8 381.3 288l-22.6 22.6-144 144z"],
    "arrow-down-arrow-up": [576,512,["sort-alt"],"f883","M438.6 57.4l96 96L557.3 176 512 221.3l-22.6-22.6L448 157.3 448 448l0 32-64 0 0-32 0-290.7-41.4 41.4L320 221.3 274.7 176l22.6-22.6 96-96L416 34.7l22.6 22.6zm-256 397.3L160 477.3l-22.6-22.6-96-96L18.7 336 64 290.7l22.6 22.6L128 354.7 128 64l0-32 64 0 0 32 0 290.7 41.4-41.4L256 290.7 301.3 336l-22.6 22.6-96 96z"],
    "arrow-down-left": [384,512,[],"e091","M64 416l-32 0 0-32 0-224 0-32 64 0 0 32 0 146.7L297.4 105.4 320 82.7 365.3 128l-22.6 22.6L141.3 352 288 352l32 0 0 64-32 0L64 416z"],
    "arrow-down-right": [384,512,[],"e093","M320 416l32 0 0-32 0-224 0-32-64 0 0 32 0 146.7L86.6 105.4 64 82.7 18.7 128l22.6 22.6L242.7 352 96 352l-32 0 0 64 32 0 224 0z"],
    "arrow-left": [448,512,["8592"],"f060","M25.4 278.6L2.7 256l22.6-22.6 144-144L192 66.7 237.2 112l-22.6 22.6L125.2 224 416 224l32 0 0 64-32 0-290.7 0 89.4 89.4L237.2 400 192 445.3l-22.6-22.6-144-144z"],
    "arrow-pointer": [320,512,["mouse-pointer"],"f245","M32 32L0 46.9 0 432l29 31.8 96.1-117.2 48.2 102.7 13.6 29 57.9-27.2-13.6-29L183.3 320 320 320l-.1-42L32 32z"],
    "arrow-right": [448,512,["8594"],"f061","M422.6 278.6L445.3 256l-22.6-22.6-144-144L256 66.7 210.8 112l22.6 22.6L322.8 224 32 224 0 224l0 64 32 0 290.7 0-89.4 89.4L210.8 400 256 445.3l22.6-22.6 144-144z"],
    "arrow-right-to-bracket": [512,512,["sign-in"],"f090","M352 96l96 0 0 320-96 0-32 0 0 64 32 0 128 0 32 0 0-32 0-384 0-32-32 0L352 32l-32 0 0 64 32 0zm-9.4 182.6L365.3 256l-22.6-22.6-128-128L192 82.7 146.7 128l22.6 22.6L242.7 224 32 224 0 224l0 64 32 0 210.7 0-73.4 73.4L146.7 384 192 429.3l22.6-22.6 128-128z"],
    "arrow-trend-down": [576,512,[],"e097","M544 416l32 0 0-32 0-160 0-32-64 0 0 32 0 82.7L342.6 137.4 320 114.7l-22.6 22.6L192 242.7 54.6 105.4 9.4 150.6l160 160L192 333.3l22.6-22.6L320 205.3 466.7 352 384 352l-32 0 0 64 32 0 160 0s0 0 0 0z"],
    "arrow-trend-up": [576,512,[],"e098","M544 96l32 0 0 32 0 160 0 32-64 0 0-32 0-82.7L342.6 374.6 320 397.3l-22.6-22.6L192 269.3 54.6 406.6 9.4 361.4l160-160L192 178.7l22.6 22.6L320 306.7 466.7 160 384 160l-32 0 0-64 32 0 160 0s0 0 0 0z"],
    "arrow-up": [384,512,["8593"],"f062","M214.6 57.4L192 34.7 169.4 57.4l-144 144L2.7 224 48 269.2l22.6-22.6L160 157.2 160 448l0 32 64 0 0-32 0-290.7 89.4 89.4L336 269.2 381.3 224l-22.6-22.6-144-144z"],
    "arrow-up-left": [384,512,[],"e09d","M64 96L32 96l0 32 0 224 0 32 64 0 0-32 0-146.7L297.4 406.6 320 429.3 365.3 384l-22.6-22.6L141.3 160 288 160l32 0 0-64-32 0L64 96z"],
    "arrow-up-right": [384,512,[],"e09f","M320 96l32 0 0 32 0 224 0 32-64 0 0-32 0-146.7L86.6 406.6 64 429.3 18.7 384l22.6-22.6L242.7 160 96 160l-32 0 0-64 32 0 224 0z"],
    "bars": [448,512,["navicon"],"f0c9","M0 64l448 0 0 64L0 128 0 64zM0 224l448 0 0 64L0 288l0-64zM448 384l0 64L0 448l0-64 448 0z"],
    "book": [448,512,["128212"],"f02d","M96 0C43 0 0 43 0 96L0 416c0 53 43 96 96 96l288 0 32 0 32 0 0-64-32 0 0-64 32 0L448 0 416 0 384 0 96 0zm0 384l256 0 0 64L96 448c-17.7 0-32-14.3-32-32s14.3-32 32-32zm32-256l224 0 0 32-224 0 0-32zm224 64l0 32-224 0 0-32 224 0z"],
    "buildings": [512,512,[],"e0cc","M512 0L192 0l0 128L0 128 0 512l192 0 320 0 0-384L512 0zM64 288l64 0 0 64-64 0 0-64zm256 32l-64 0 0-64 64 0 0 64zm64 0l0-64 64 0 0 64-64 0zM128 192l0 64-64 0 0-64 64 0zM256 64l64 0 0 64-64 0 0-64zm192 0l0 64-64 0 0-64 64 0zM256 224l0-64 64 0 0 64-64 0zm192 0l-64 0 0-64 64 0 0 64z"],
    "calendar-days": [448,512,["calendar-alt"],"f073","M160 0l0 64 128 0 0-64 64 0 0 64 96 0 0 96L0 160 0 64l96 0L96 0l64 0zM0 192l448 0 0 320L0 512 0 192zM64 320l64 0 0-64-64 0 0 64zm128-64l0 64 64 0 0-64-64 0zm192 64l0-64-64 0 0 64 64 0zM64 448l64 0 0-64-64 0 0 64zm192-64l-64 0 0 64 64 0 0-64zm64 64l64 0 0-64-64 0 0 64z"],
    "camera-retro": [512,512,["128247"],"f083","M220.6 121.2L271.1 96 448 96l0 96-114.8 0c-21.9-15.1-48.5-24-77.2-24s-55.2 8.9-77.2 24L64 192l0-64 128 0c9.9 0 19.7-2.3 28.6-6.8zM256 32L192 64l-32 0 0-32L64 32l0 32L0 64l0 64L0 416l0 64 64 0 384 0 64 0 0-64 0-320 0-64-64 0L256 32zM168 304a88 88 0 1 1 176 0 88 88 0 1 1 -176 0z"],
    "caret-down": [320,512,[],"f0d7","M320 240L160 384 0 240l0-48 320 0 0 48z"],
    "caret-left": [256,512,[],"f0d9","M144 96L0 256 144 416l48 0 0-320-48 0z"],
    "caret-right": [256,512,[],"f0da","M112 96L256 256 112 416l-48 0L64 96l48 0z"],
    "caret-up": [320,512,[],"f0d8","M0 272L160 128 320 272v48H0V272z"],
    "cart-shopping": [576,512,["128722","shopping-cart"],"f07a","M24 0L0 0 0 48l24 0 52.1 0 60.3 316.5 3.7 19.5 19.9 0 328 0 24 0 0-48-24 0-308.1 0-9.1-48L496 288 576 32 122 32l-2.4-12.5L115.9 0 96 0 24 0zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm336-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"],
    "chart-area": [512,512,["area-chart"],"f1fe","M64 64l0-32L0 32 0 64 0 448l0 32 32 0 448 0 32 0 0-64-32 0L64 416 64 64zm64 288l352 0 0-112L384 128l-64 64L240 96 128 224l0 128z"],
    "chart-bar": [512,512,["bar-chart"],"f080","M64 32l0 32 0 352 416 0 32 0 0 64-32 0L32 480 0 480l0-32L0 64 0 32l64 0zm64 64l32 0 192 0 32 0 0 64-32 0-192 0-32 0 0-64zm32 96l128 0 32 0 0 64-32 0-128 0-32 0 0-64 32 0zm0 96l256 0 32 0 0 64-32 0-256 0-32 0 0-64 32 0z"],
    "chart-column": [512,512,[],"e0e3","M64 32l0 32 0 352 416 0 32 0 0 64-32 0L32 480 0 480l0-32L0 64 0 32l64 0zM192 224l0 32 0 64 0 32-64 0 0-32 0-64 0-32 64 0zm96-64l0 160 0 32-64 0 0-32 0-160 0-32 64 0 0 32zm96 32l0 32 0 96 0 32-64 0 0-32 0-96 0-32 64 0zm96-96l0 224 0 32-64 0 0-32 0-224 0-32 64 0 0 32z"],
    "chart-line": [512,512,["line-chart"],"f201","M64 64l0-32L0 32 0 64 0 448l0 32 32 0 448 0 32 0 0-64-32 0L64 416 64 64zM342.6 278.6l128-128-45.3-45.3L320 210.7l-57.4-57.4L240 130.7l-22.6 22.6-112 112 45.3 45.3L240 221.3l57.4 57.4L320 301.3l22.6-22.6z"],
    "chart-line-down": [512,512,["128201"],"f64d","M64 64l0-32L0 32 0 64 0 448l0 32 32 0 448 0 32 0 0-64-32 0L64 416 64 64zM304 98.7l-22.6 22.6L208 194.7l-57.4-57.4-45.3 45.3 80 80L208 285.3l22.6-22.6L304 189.3l57.4 57.4L320 288l32 32 128 0 0-128-32-32-41.4 41.4-80-80L304 98.7z"],
    "chart-line-up": [512,512,[],"e0e5","M64 64l0-32L0 32 0 64 0 448l0 32 32 0 448 0 32 0 0-64-32 0L64 416 64 64zm288 64l-32 32 41.4 41.4L304 258.7l-73.4-73.4L208 162.7l-22.6 22.6-80 80 45.3 45.3L208 253.3l73.4 73.4L304 349.3l22.6-22.6 80-80L448 288l32-32 0-128-128 0z"],
    "chart-mixed": [512,512,["analytics"],"f643","M340 217L500 89 460 39 319.4 151.5 211.2 70.4 191.4 55.5 172 71 12 199l40 50L192.6 136.5l108.2 81.1 19.8 14.9L340 217zm-180 7l0 256 64 0 0-256-64 0zM32 320l0 160 64 0 0-160-64 0zm320-32l-64 0 0 192 64 0 0-192zm64-64l0 256 64 0 0-256-64 0z"],
    "chart-network": [640,512,[],"f78a","M288 0L160 0l0 128 58.6 0 29.1 62.3C221.8 210.4 203 239 195.6 272L128 272l0-32L0 240 0 368l128 0 0-32 67.6 0c14.6 64.1 71.9 112 140.4 112c38.4 0 73.3-15 99.1-39.5L512 459.8l0 52.2 128 0 0-128-126.3 0-43.1-28.7c6.1-15.9 9.4-33.2 9.4-51.3c0-20.3-4.2-39.7-11.8-57.2L542.8 192l97.2 0 0-128L512 64l0 71.3-81.7 59.9C405 173.3 372.1 160 336 160c-10.4 0-20.6 1.1-30.4 3.2L288 125.5 288 0zm48 256a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"],
    "chart-pie": [576,512,["pie-chart"],"f200","M304 240L304 .6c5.3-.4 10.6-.6 16-.6C443.7 0 544 100.3 544 224c0 5.4-.2 10.7-.6 16L304 240zM32 272C32 144.8 130.9 40.8 256 32.5L256 288 425 457c-41.5 34.4-94.8 55-153 55C139.5 512 32 404.6 32 272zm288 16l255.5 0C571 355.9 538.3 416.1 489 457L320 288z"],
    "check": [448,512,["10004","10003"],"f00c","M447.9 142.5l-23.2 22L181 395.3l-22 20.8-22-20.8L23.2 287.6 0 265.6l44-46.5 23.2 22L159 328 380.7 118l23.2-22 44 46.5z"],
    "circle": [512,512,["61915","61708","11044","9899","9898","9679","128996","128995","128994","128993","128992","128309","128308"],"f111","M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z"],
    "circle-user": [512,512,["62142","user-circle"],"f2bd","M391.9 391.6L368 320l-224 0-23.9 71.6C154.9 426.5 202.9 448 256 448s101.1-21.5 135.9-56.4zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 16a72 72 0 1 0 0-144 72 72 0 1 0 0 144z"],
    "copy": [448,512,[],"f0c5","M352 0l96 96 0 288-288 0L160 0 352 0zM64 128l64 0 0 64-64 0 0 256 192 0 0-32 64 0 0 32 0 64-64 0L64 512 0 512l0-64L0 192l0-64 64 0z"],
    "database": [448,512,[],"f1c0","M448 80l0 32 0 16 0 16L320 224l-192 0L0 144l0-16 0-16L0 80 128 0 320 0 448 80zM0 432l0-90.3L118.8 416l210.4 0L448 341.7l0 90.3L320 512l-192 0L0 432zM448 288l0 16L320 384l-192 0L0 304l0-16L0 181.7 118.8 256l210.4 0L448 181.7 448 288z"],
    "download": [512,512,[],"f019","M288 32l0-32L224 0l0 32 0 242.7-73.4-73.4L128 178.7 82.7 224l22.6 22.6 128 128L256 397.3l22.6-22.6 128-128L429.3 224 384 178.7l-22.6 22.6L288 274.7 288 32zM0 512l512 0 0-160-165.5 0-45.3 45.3L256 442.5l-45.3-45.3L165.5 352 0 352 0 512zM432 408a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"],
    "ellipsis-vertical": [128,512,["ellipsis-v"],"f142","M16 48l96 0 0 96-96 0 0-96zm0 160l96 0 0 96-96 0 0-96zm96 160l0 96-96 0 0-96 96 0z"],
    "envelope": [512,512,["61443","9993","128386"],"f0e0","M0 64l512 0 0 80L256 320 0 144 0 64zM0 448L0 182.8 237.9 346.4 256 358.8l18.1-12.5L512 182.8 512 448 0 448z"],
    "file-lines": [384,512,["61686","128462","128441","file-alt","file-text"],"f15c","M224 0L0 0 0 512l384 0 0-352-160 0L224 0zm32 0l0 128 128 0L256 0zM112 256l160 0 16 0 0 32-16 0-160 0-16 0 0-32 16 0zm0 64l160 0 16 0 0 32-16 0-160 0-16 0 0-32 16 0zm0 64l160 0 16 0 0 32-16 0-160 0-16 0 0-32 16 0z"],
    "gear": [512,512,["9881","cog"],"f013","M200 0L312 0l17.2 78.4c15.8 6.5 30.6 15.1 44 25.4l76.5-24.4 56 97-59.4 54.1c1.1 8.3 1.7 16.8 1.7 25.4s-.6 17.1-1.7 25.4l59.4 54.1-56 97-76.5-24.4c-13.4 10.3-28.2 18.9-44 25.4L312 512l-112 0-17.2-78.4c-15.8-6.5-30.6-15.1-44-25.4L62.3 432.5l-56-97 59.4-54.1C64.6 273.1 64 264.6 64 256s.6-17.1 1.7-25.4L6.3 176.5l56-97 76.5 24.4c13.4-10.3 28.2-18.9 44-25.4L200 0zm56 336a80 80 0 1 0 0-160 80 80 0 1 0 0 160z"],
    "gears": [640,512,["cogs"],"f085","M125 8l70 0 10 48.1c13.8 5.2 26.5 12.7 37.5 22L285.6 64 320 123.4l-33.9 30.3c1.3 7.3 1.9 14.7 1.9 22.3s-.7 15.1-1.9 22.3L320 228.6 285.6 288l-43.1-14.2c-11.1 9.3-23.7 16.8-37.5 22L195 344l-70 0-10-48.1c-13.8-5.2-26.5-12.7-37.5-22L34.4 288 0 228.6l33.9-30.3C32.7 191.1 32 183.6 32 176s.7-15.1 1.9-22.3L0 123.4 34.4 64 77.5 78.2c11.1-9.3 23.7-16.8 37.5-22L125 8zm83 168a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM632 386.4l-47.8 9.8c-4.9 13.4-12 25.8-20.9 36.7l15 44.8L517.7 512l-30.9-34c-7.4 1.3-15 2-22.7 2s-15.4-.7-22.7-2l-30.9 34-60.6-34.4 15-44.8c-8.9-10.9-16-23.3-20.9-36.7L296 386.4l0-68.7 47.8-9.8c4.9-13.4 12-25.8 20.9-36.7l-15-44.8L410.3 192l30.9 34c7.4-1.3 15-2 22.7-2s15.4 .7 22.7 2l30.9-34 60.6 34.4-15 44.8c8.9 10.9 16 23.3 20.9 36.7l47.8 9.8 0 68.7zM464 400a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"],
    "hotel": [512,512,["127976"],"f594","M0 0L512 0l0 64-32 0 0 384 32 0 0 64-208 0 0-96-96 0 0 96L0 512l0-64 32 0L32 64 0 64 0 0zM96 96l0 64 64 0 0-64L96 96zm192 0l-64 0 0 64 64 0 0-64zm64 0l0 64 64 0 0-64-64 0zM160 192l-64 0 0 64 64 0 0-64zm64 0l0 64 64 0 0-64-64 0zm192 0l-64 0 0 64 64 0 0-64zM352 384c0-53-43-96-96-96s-96 43-96 96l192 0z"],
    "image": [512,512,[],"f03e","M0 32l512 0 0 448L0 480 0 32zM323.5 202.1L304 174.7l-19.5 27.3L196.2 325.6l-26.3-29.6L152 275.9l-17.9 20.2-64 72L64 374.9l0 9.1 0 8 0 24 24 0 72 0 24 0 32 0 24 0 184 0 24 0 0-24 0-8 0-7.7-4.5-6.3-120-168zM112 192a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"],
    "inbox": [512,512,[],"f01c","M96 32L71 32 65 56.2 1 312.2l-1 3.8L0 320 0 448l0 32 32 0 448 0 32 0 0-32 0-128 0-3.9-1-3.8-64-256L441 32l-25 0L96 32zM73 288L121 96l270 0 48 192-71 0-32 64-160 0-32-64-71 0z"],
    "list": [512,512,["list-squares"],"f03a","M112 48L16 48l0 96 96 0 0-96zm80 16l-32 0 0 64 32 0 288 0 32 0 0-64-32 0L192 64zm0 160l-32 0 0 64 32 0 288 0 32 0 0-64-32 0-288 0zm0 160l-32 0 0 64 32 0 288 0 32 0 0-64-32 0-288 0zM16 208l0 96 96 0 0-96-96 0zm96 160l-96 0 0 96 96 0 0-96z"],
    "location-dot": [384,512,["map-marker-alt"],"f3c5","M192 512s192-208 192-320C384 86 298 0 192 0S0 86 0 192C0 304 192 512 192 512zm0-384a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"],
    "lock": [448,512,["128274"],"f023","M144 144l0 48 160 0 0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80zM80 192l0-48C80 64.5 144.5 0 224 0s144 64.5 144 144l0 48 80 0 0 320L0 512 0 192l80 0z"],
    "magnifying-glass": [512,512,["128269","search"],"f002","M416 208c0 45.9-14.9 88.3-40 122.7L486.6 441.4 509.3 464 464 509.3l-22.6-22.6L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"],
    "message-question": [512,512,[],"e1e3","M0 0L512 0l0 416-208 0L160 512l0-96L0 416 0 0zM168 136l0 6.5 48 0 0-6.5c0-4.4 3.6-8 8-8l56.9 0c8.4 0 15.1 6.8 15.1 15.1c0 5.4-2.9 10.4-7.6 13.1l-44.3 25.4L232 188.6l0 13.9 0 21.5 0 24 48 0 0-24 0-7.6 32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8c0-34.9-28.3-63.1-63.1-63.1L224 80c-30.9 0-56 25.1-56 56zm64 152l0 48 48 0 0-48-48 0z"],
    "minus": [448,512,["10134","8722","8211","subtract"],"f068","M432 288l-32 0L48 288l-32 0 0-64 32 0 352 0 32 0 0 64z"],
    "paperclip": [448,512,["128206"],"f0c6","M325.5 60c-16.6 0-32.5 6.6-44.2 18.3L91.6 268C71.4 288.2 60 315.7 60 344.2C60 403.8 108.2 452 167.8 452c28.6 0 56-11.4 76.2-31.6L404.2 260.2l39.6 39.6L283.6 460c-30.7 30.7-72.4 48-115.8 48C77.3 508 4 434.7 4 344.2c0-43.4 17.3-85.1 48-115.8L241.7 38.7C263.9 16.5 294.1 4 325.5 4C390.9 4 444 57.1 444 122.5c0 31.4-12.5 61.6-34.7 83.8L225.1 390.5c-13.7 13.7-32.4 21.5-51.8 21.5c-40.5 0-73.3-32.8-73.3-73.3c0-19.4 7.7-38.1 21.5-51.8L284.2 124.2l39.6 39.6L161.1 326.5c-3.2 3.2-5.1 7.6-5.1 12.2c0 9.5 7.7 17.3 17.3 17.3c4.6 0 9-1.8 12.2-5.1L369.7 166.7C381.4 155 388 139.1 388 122.5C388 88 360 60 325.5 60z"],
    "pen": [512,512,["128394"],"f304","M0 512L32 352 292.7 91.3l128 128L160 480 0 512zM443.3 196.7l-128-128L384 0 512 128l-68.7 68.7z"],
    "person-digging": [576,512,["digging"],"f85e","M256 112a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM41.2 201.8l-22.2-9.2L.6 236.9l22.2 9.2 347.9 145L352 416l-64 0-32 96 320 0 0-48L448 288l-47.6 63.5-91.9-38.3L253.6 179.8l-5.1-12.5-12.6-5-80-32-22-8.8L119 140 62.5 210.7l-21.2-8.8zm17.1 90.1L49 328 1.3 512l66.1 0 34.2-131.9 58.4 25 0 74.9 0 32 64 0 0-32 0-96 0-21.1-19.4-8.3-112-48L58.4 291.9z"],
    "phone": [512,512,["128379","128222"],"f095","M0 32L144 0l80 144-83.8 67c36.1 68.4 92.3 124.6 160.8 160.8L368 288l144 80L480 512H448C200.6 512 0 311.4 0 64L0 32z"],
    "play-pause": [640,512,[],"e22f","M320 256L64 448 64 64 320 256zM448 96l0 320 0 32-64 0 0-32 0-320 0-32 64 0 0 32zm128 0l0 320 0 32-64 0 0-32 0-320 0-32 64 0 0 32z"],
    "plus": [448,512,["61543","10133","add"],"2b","M256 80l0-32-64 0 0 32 0 144L48 224l-32 0 0 64 32 0 144 0 0 144 0 32 64 0 0-32 0-144 144 0 32 0 0-64-32 0-144 0 0-144z"],
    "plus-minus": [384,512,[],"e43c","M224 32l0-32L160 0l0 32 0 112L48 144l-32 0 0 64 32 0 112 0 0 112 0 32 64 0 0-32 0-112 112 0 32 0 0-64-32 0-112 0 0-112zM32 448L0 448l0 64 32 0 320 0 32 0 0-64-32 0L32 448z"],
    "podcast": [448,512,[],"f2ce","M316 374c50.4-31 84-86.6 84-150c0-97.2-78.8-176-176-176S48 126.8 48 224c0 63.5 33.6 119.1 84 150l8.3 57.8C58 398.6 0 318.1 0 224C0 100.3 100.3 0 224 0S448 100.3 448 224c0 94.1-58 174.6-140.2 207.8L316 374zm3.3-42.1L313 324l-23.7-29.6C308.2 276.9 320 251.8 320 224c0-53-43-96-96-96s-96 43-96 96c0 27.8 11.8 52.9 30.7 70.4L135 324l-6.3 7.9C98.8 305.5 80 267 80 224c0-79.5 64.5-144 144-144s144 64.5 144 144c0 43-18.8 81.5-48.7 107.9zM160 344l32-40 64 0 32 40L264 512l-80 0L160 344zm64-176a56 56 0 1 1 0 112 56 56 0 1 1 0-112z"],
    "print": [512,512,["9113","128438","128424"],"f02f","M96 0L368 0l13.3 0 9.4 9.4 48 48 9.4 9.4L448 80l0 80-64 0 0-66.7L354.7 64 128 64l0 96-64 0L64 32 64 0 96 0zM64 384L0 384 0 192l512 0 0 192-64 0 0 96 0 32-32 0L96 512l-32 0 0-32 0-96zm64 0l0 64 256 0 0-64 0-32-256 0 0 16 0 16zM408 248l0 48 48 0 0-48-48 0z"],
    "quote-left": [448,512,["8220","quote-left-alt"],"f10d","M0 216C0 149.7 53.7 96 120 96l8 0 32 0 0 64-32 0-8 0c-30.9 0-56 25.1-56 56l0 8 128 0 0 192L0 416l0-96 0-96 0-8zm256 0c0-66.3 53.7-120 120-120l8 0 32 0 0 64-32 0-8 0c-30.9 0-56 25.1-56 56l0 8 128 0 0 192-192 0 0-96 0-96 0-8z"],
    "reflect-horizontal": [512,512,[],"e664","M280 0L232 0l0 24 0 464 0 24 48 0 0-24 0-464 0-24zM32 416L192 256 32 96 0 96 0 416l32 0zM320 256L480 416l32 0 0-320-32 0L320 256z"],
    "square": [448,512,["61590","9724","9723","9632"],"f0c8","M0 32H448V480H0V32z"],
    "square-arrow-down": [448,512,["arrow-square-down"],"f339","M448 480L0 480 0 32l448 0 0 448zM241 409L353 297l17-17L336 246.1l-17 17-71 71L248 120l0-24-48 0 0 24 0 214.1-71-71-17-17L78.1 280l17 17L207 409l17 17 17-17z"],
    "square-arrow-down-left": [448,512,[],"e261","M448 480L0 480 0 32l448 0 0 448zM136 368l152 0 24 0 0-48-24 0-94.1 0L329 185l17-17L312 134.1l-17 17-135 135L160 184l0-24-48 0 0 24 0 160 0 24 24 0z"],
    "square-arrow-down-right": [448,512,[],"e262","M0 480l448 0 0-448L0 32 0 480zM312 368l-152 0-24 0 0-48 24 0 94.1 0L119 185l-17-17L136 134.1l17 17 135 135L288 184l0-24 48 0 0 24 0 160 0 24-24 0z"],
    "square-arrow-left": [448,512,["arrow-square-left"],"f33a","M0 32L0 480l448 0 0-448L0 32zM71 239L183 127l17-17L233.9 144l-17 17-71 71L360 232l24 0 0 48-24 0-214.1 0 71 71 17 17L200 401.9l-17-17L71 273l-17-17 17-17z"],
    "square-arrow-right": [448,512,["arrow-square-right"],"f33b","M448 480l0-448L0 32 0 480l448 0zM377 273L265 385l-17 17L214.1 368l17-17 71-71L88 280l-24 0 0-48 24 0 214.1 0-71-71-17-17L248 110.1l17 17L377 239l17 17-17 17z"],
    "square-arrow-up": [448,512,["arrow-square-up"],"f33c","M448 32L0 32 0 480l448 0 0-448zM241 103L353 215l17 17L336 265.9l-17-17-71-71L248 392l0 24-48 0 0-24 0-214.1-71 71-17 17L78.1 232l17-17L207 103l17-17 17 17z"],
    "square-arrow-up-left": [448,512,[],"e263","M448 32L0 32 0 480l448 0 0-448zM136 144l152 0 24 0 0 48-24 0-94.1 0L329 327l17 17L312 377.9l-17-17-135-135L160 328l0 24-48 0 0-24 0-160 0-24 24 0z"],
    "square-arrow-up-right": [448,512,["external-link-square"],"f14c","M0 32l448 0 0 448L0 480 0 32zM312 144l-152 0-24 0 0 48 24 0 94.1 0L119 327l-17 17L136 377.9l17-17 135-135L288 328l0 24 48 0 0-24 0-160 0-24-24 0z"],
    "square-check": [448,512,["61510","9989","9745","check-square"],"f14a","M448 32L0 32 0 480l448 0 0-448zM337 209L209 337l-17 17-17-17-64-64-17-17L128 222.1l17 17 47 47L303 175l17-17L353.9 192l-17 17z"],
    "square-chevron-down": [448,512,["chevron-square-down"],"f329","M0 480l448 0 0-448L0 32 0 480zM207 345L103 241l-17-17L120 190.1l17 17 87 87 87-87 17-17L361.9 224l-17 17L241 345l-17 17-17-17z"],
    "square-chevron-left": [448,512,["chevron-square-left"],"f32a","M0 32L0 480l448 0 0-448L0 32zM135 239L239 135l17-17L289.9 152l-17 17-87 87 87 87 17 17L256 393.9l-17-17L135 273l-17-17 17-17z"],
    "square-chevron-right": [448,512,["chevron-square-right"],"f32b","M448 480l0-448L0 32 0 480l448 0zM313 273L209 377l-17 17L158.1 360l17-17 87-87-87-87-17-17L192 118.1l17 17L313 239l17 17-17 17z"],
    "square-chevron-up": [448,512,["chevron-square-up"],"f32c","M448 32L0 32 0 480l448 0 0-448zM241 167L345 271l17 17L328 321.9l-17-17-87-87-87 87-17 17L86.1 288l17-17L207 167l17-17 17 17z"],
    "square-exclamation": [448,512,["exclamation-square"],"f321","M448 32L0 32 0 480l448 0 0-448zM248 128l0 24 0 112 0 24-48 0 0-24 0-112 0-24 48 0zM200 320l48 0 0 48-48 0 0-48z"],
    "square-info": [448,512,["8505","info-square"],"f30f","M448 32L0 32 0 480l448 0 0-448zM184 336l24 0 0-64-24 0-24 0 0-48 24 0 48 0 24 0 0 24 0 88 8 0 24 0 0 48-24 0-80 0-24 0 0-48 24 0zm72-208l0 64-64 0 0-64 64 0z"],
    "square-minus": [448,512,["61767","minus-square"],"f146","M448 32L0 32 0 480l448 0 0-448zM152 232l144 0 24 0 0 48-24 0-144 0-24 0 0-48 24 0z"],
    "square-plus": [448,512,["61846","plus-square"],"f0fe","M448 32L0 32 0 480l448 0 0-448zM200 368l0-24 0-64-64 0-24 0 0-48 24 0 64 0 0-64 0-24 48 0 0 24 0 64 64 0 24 0 0 48-24 0-64 0 0 64 0 24-48 0z"],
    "square-question": [448,512,["question-square"],"f2fd","M448 32L0 32 0 480l448 0 0-448zM136 184c0-30.9 25.1-56 56-56l56.9 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L248 264.4l0 23.6-48 0 0-24 0-13.5 0-13.9 12.1-6.9 44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1L192 176c-4.4 0-8 3.6-8 8l0 6.5-48 0 0-6.5zm64 136l48 0 0 48-48 0 0-48z"],
    "square-user": [448,512,[],"e283","M368 416l-32-96-224 0L80 416l288 0zM0 32l64 0 320 0 64 0 0 64 0 320 0 64-64 0L64 480 0 480l0-64L0 96 0 32zM224 272a72 72 0 1 0 0-144 72 72 0 1 0 0 144z"],
    "square-xmark": [448,512,["10062","times-square","xmark-square"],"f2d3","M448 32L0 32 0 480l448 0 0-448zM321.9 192l-17 17-47 47 47 47 17 17L288 353.9l-17-17-47-47-47 47-17 17L126.1 320l17-17 47-47-47-47-17-17L160 158.1l17 17 47 47 47-47 17-17L321.9 192z"],
    "star-sharp": [576,512,[],"e28b","M288.1 0l63.5 195.6H557.2L390.9 316.4 454.4 512 288.1 391.1 121.7 512l63.5-195.6L18.9 195.6H224.5L288.1 0z"],
    "trash": [448,512,[],"f1f8","M144 0L128 32 0 32 0 96l448 0 0-64L320 32 304 0 144 0zM416 128L32 128 56 512l336 0 24-384z"],
    "up-right-from-square": [512,512,["external-link-alt"],"f35d","M512 176l-32 32-65.4-65.4-168 168L224 333.3 178.7 288l22.6-22.6 168-168L304 32 336 0 512 0l0 176zM0 32l32 0 128 0 32 0 0 64-32 0L64 96l0 352 352 0 0-96 0-32 64 0 0 32 0 128 0 32-32 0L32 512 0 512l0-32L0 64 0 32z"],
    "user": [448,512,["62144","128100"],"f007","M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zM448 512L384 304 64 304 0 512l448 0z"],
    "xmark": [384,512,["215","10060","10006","10005","128473","close","multiply","remove","times"],"f00d","M326.6 166.6L349.3 144 304 98.7l-22.6 22.6L192 210.7l-89.4-89.4L80 98.7 34.7 144l22.6 22.6L146.7 256 57.4 345.4 34.7 368 80 413.3l22.6-22.6L192 301.3l89.4 89.4L304 413.3 349.3 368l-22.6-22.6L237.3 256l89.4-89.4z"]

  };
  var prefixes = [null    ,'fass',
    ,'fa-solid'
];
  bunker(() => {
    for (const prefix of prefixes) {
      if (!prefix) continue;
      defineIcons(prefix, icons);
    }
  });

}());
